import { render, staticRenderFns } from "./AssetCardHeader.vue?vue&type=template&id=2cbd8454&scoped=true&lang=pug"
import script from "./AssetCardHeader.vue?vue&type=script&lang=js"
export * from "./AssetCardHeader.vue?vue&type=script&lang=js"
import style0 from "./AssetCardHeader.vue?vue&type=style&index=0&id=2cbd8454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbd8454",
  null
  
)

export default component.exports